import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import HealthSystemAdmin from './HealthSystemAdmin';
import HospitalAdmin from './HospitalAdmin';
import ServiceLineAdmin from './ServiceLineAdmin';
import NewProfile from './ViewProfile';
import AddHealthSystemAdmin from './AddHealthSystemAdmin';
import AddHospitalAdmin from './AddHospitalAdmin';
import AddServiceLineAdmin from './AddServiceLineAdmin';
import HealthSystemInfo from './HealthSystemInfo';
import HospitalInfo from './HospitalInfo';
import ServiceLineInfo from './ServiceLineInfo';
import ProviderInfo from './ProviderInfo';
import ContactUs from './ContactUs';
import ErrorBoundary from '../../ErrorBoundary';

class AboutUsTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName")
        }
    }
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/about";
            var path1 = window.origin + "/my-jeeva/projectmgmt/about/";
            if (currentPath == path || currentPath == path1) {
                $("#about").addClass('active');
            } else if (currentPath.includes('/projectmgmt/about/contact-information') ||
                currentPath.includes('/projectmgmt/about/contact-information/')) {
                $("#add-admin").addClass('active');
            } else if (currentPath.includes('/projectmgmt/about/add-admin') ||
                currentPath.includes('/projectmgmt/about/add-admin/')) {
                $("#add-admin").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("last-project-about-tab")).addClass('active')
            }
            $("#about,#add-admin,#contact-information")
                .on("click", function () {
                    $("#about,#add-admin,#contact-information")
                        .removeClass('active');
                    localStorage.setItem("last-project-about-tab", $(this)[0].id);

                    $(this).addClass('active')

                })



        })();
    }

    render() {
        return (
           <ErrorBoundary>
            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-4">
                                    <h1 className="m-0 page-title">About Us</h1>
                                </div>
                                <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                    <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>{this.state.showHomeEnityName}</h1>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="border-bottom"></div>
                        <div className="tab-class">

                            <ul className="nav nav-tabs border-bottom navCluster">

                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/about" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="about" style={{ marginRight: '15px' }}>
                                        Account Information
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/about/add-admin" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="add-admin" style={{ marginRight: '15px' }}>
                                        Add Administrators
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/about/contact-information" style={{ textDecoration: 'none', display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'none' : 'block' }}>
                                    <li className="nav-link" id="contact-information" style={{ marginRight: '15px', display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'none' : 'block' }}>
                                        Contact Information
                                    </li></Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/about/contact-information" component={ContactUs}></Route>
                    <Route path="/projectmgmt/about/add-admin" component={(window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? AddHealthSystemAdmin :
                        ((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) ? AddHospitalAdmin : AddServiceLineAdmin)}></Route>
                    <Route path="/projectmgmt/about" component={((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? HealthSystemInfo :
                        ((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) ? HospitalInfo :
                            ((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.SERVICELINE_ADMIN) ? ServiceLineInfo : ProviderInfo)))}></Route>
                </Switch>
            </div>
            </ErrorBoundary>
        );
    }
}
export default AboutUsTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/AboutUsTabSettings.js